export const documentsList = [
  {
    name: "gap-cover-claim",
    documents: [
      "Service provider's invoice/ Doctors account",
      "Hospital bill",
      "Medical scheme statement",
    ],
  },
  {
    name: "sub-limit-enhancer",
    documents: [
      "Hospital bill",
      "Service provider's invoice/ Doctors account",
      "Medical scheme statement",
      "Authorisation letter from the medical scheme",
    ],
  },
  {
    name: "step-down-claim",
    documents: ["Facility invoice", "Medical scheme statement"],
  },
  {
    name: "admission-fee-claims",
    documents: ["Hospital bill", "Medical scheme statement"],
  },
  {
    name: "procedure-co-payments",
    documents: [
      "Hospital bill",
      "Medical scheme brochure",
      "Medical scheme statement",
      "Proof of co-payment",
    ],
  },
  {
    name: "penalty-fee-claims",
    documents: [
      "Hospital bill",
      "Medical scheme statement",
      "Authorisation letter from the medical scheme",
    ],
  },
  {
    name: "emergency-room-cover-accident-and-child-emergency-illness",
    documents: [
      "Casualty/ Emergency Room account",
      "Service provider's invoice/ Doctors account",
    ],
  },
  {
    name: "emergency-room-cover-illness-benefit",
    documents: [
      "Casualty/ Emergency Room account",
      "Service provider's invoice/ Doctors account",
      "Medical scheme statement",
    ],
  },
  {
    name: "emergency-room-cover-accident-benefit",
    documents: [
      "Casualty/ Emergency Room account",
      "Service provider's invoice/ Doctors account",
    ],
  },
  {
    name: "cancer-boost",
    documents: [
      "Service provider's invoice/ Doctors account",
      "Medical scheme statement",
      "Confirmation of oncology registration programme",
    ],
  },
  {
    name: "cancer-benefit",
    documents: [
      "Service provider's invoice/ Doctors account",
      "Medical scheme statement",
    ],
  },
];
